import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-empty-nav-bar',
    templateUrl: './empty-nav-bar.component.html',
    styleUrls: ['./empty-nav-bar.component.css'],
    standalone: false
})
export class EmptyNavBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
